import HBIcon from "@/components/HBIcon";
import PinSourcePreview from "@/components/PinSourcePreview";
import UserGuideTooltip from "@/components/UserGuideTooltip";
import { SOURCE_TYPE_ICONS } from "@/constants/sourceTypeIcon";
import { Button } from "antd";
import styles from "./index.module.less";

/**
 * 关注来源信息,主要在关注页使用
 */
export default function PinSource({ pin }) {
  // 跳转对象详情
  const onLinkFollowerDetail = (pin) => {
    const { source_type, source_detail } = pin;
    let source_link = "";

    if (source_type === 1) {
      // 画板
      source_link = `/boards/${source_detail?.board_id}`;
    } else if (source_type === 2) {
      // 用户
      source_link = `/user/${source_detail?.urlname}`;
    } else if (source_type === 3) {
      // 来源
      source_link = `/domains/${source_detail?.domain_id}`;
    }
    window.open(source_link);
  };

  return (
    <PinSourcePreview pin={pin}>
      <UserGuideTooltip
        hideType="hover"
        title={
          <div className={styles.tooltipTitle}>
            <div>采集来自</div>
            <div
              title={
                pin.source_detail?.domain_name ||
                pin.source_detail?.title ||
                pin.source_detail?.username
              }
            >
              你关注的「
              {pin.source_detail?.domain_name ||
                pin.source_detail?.title ||
                pin.source_detail?.username}
              」
            </div>
          </div>
        }
        placement={"right"}
        visible={pin.source_type === 3}
        needUserId={false}
        localStorageKey={"_PINIT_FRONT_USER_GUIDE_SIGN_FOLLOW_PIN_CARD"}
        autoAdjustOverflow={false}
        align={{
          offset: [-10, 0],
        }}
      >
        <Button
          className={styles.btn}
          style={{ marginRight: "8px" }}
          title="来源"
          onClick={() => onLinkFollowerDetail(pin)}
        >
          <HBIcon type={SOURCE_TYPE_ICONS[pin.source_type]} />
        </Button>
      </UserGuideTooltip>
    </PinSourcePreview>
  );
}
